const ensureTrailingSlash = (value) => value.endsWith("/") ? value : `${value}/`
const removeTrailingSlash = (value) => value.replace(/\/+$/, "")

const siteOrigin =
	typeof window !== "undefined" && window.location && window.location.origin ?
	window.location.origin :
	""

const baseUrl = {
	commonUrl: ensureTrailingSlash(process.env.VUE_APP_API_BASE || "/api/"),
	imgUrl: removeTrailingSlash(process.env.VUE_APP_FILE_BASE || siteOrigin),
	biographyUrl: process.env.VUE_APP_BIOGRAPHY_URL || "https://www.jt720.cn/pano/zzmt025cg03im7r3?s=scene_plovlw61mqereg7f",
	item2IframeUrl: process.env.VUE_APP_ITEM2_IFRAME_URL || "https://cs-1259461973.cos.ap-nanjing.myqcloud.com/hucheng/show/index.html",
	item2VideoUrl: process.env.VUE_APP_ITEM2_VIDEO_URL || "/UploadPic/2021-8/hucheng.mp4",
	vrRightUrl: process.env.VUE_APP_VR_RIGHT_URL || "https://www.jt720.cn/pano/8mo85do277semofy?s=scene_74xmc8bjh9eqwi7a",
	vrLeftUrl: process.env.VUE_APP_VR_LEFT_URL || "https://www.jt720.cn/pano/ksmcvfwsugi4504h?s=scene_c5p852ctxyt6m70h"
}

export default baseUrl
